/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Import,
  Imports,
  ImportsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * Get a List of Imports
 * @summary Imports list
 */
export const imports = (
    params?: MaybeRefOrGetter<ImportsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Imports>(
      {url: `/imports`, method: 'GET',
        params, signal
    },
      );
    }




export const getImportsQueryKey = (params?: MaybeRefOrGetter<ImportsParams>,) => {
    return [
    'imports', ...(params ? [params] : [])
    ] as const;
    }


export const getImportsQueryOptions = <TData = Awaited<ReturnType<typeof imports>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ImportsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof imports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof imports>>> = ({ signal }) => imports(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof imports>>, TError, TData>
}

export type ImportsQueryResult = NonNullable<Awaited<ReturnType<typeof imports>>>
export type ImportsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Imports list
 */

export function useImports<TData = Awaited<ReturnType<typeof imports>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ImportsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof imports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Import Detail
 */
export const _import = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Import>(
      {url: `/imports/${id}`, method: 'GET', signal
    },
      );
    }




export const getImportQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'imports',id
    ] as const;
    }


export const getImportQueryOptions = <TData = Awaited<ReturnType<typeof _import>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof _import>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof _import>>> = ({ signal }) => _import(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof _import>>, TError, TData>
}

export type _ImportQueryResult = NonNullable<Awaited<ReturnType<typeof _import>>>
export type _ImportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Import Detail
 */

export function useImport<TData = Awaited<ReturnType<typeof _import>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof _import>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






